import init from '~/index';
import '@/styled-system/styles.css';

init();
